import React from 'react';
import NotesMainPanel from '../../components/workspace/NotesMainPanel';
import { useDashboardData } from '../../components/DashboardShell';
import { useLocale } from '../../context/LocaleContext';

export default function SettingsCannedResponsesPage() {
  const { data } = useDashboardData();
  const { t } = useLocale();
  const items = data?.workspace?.cannedResponses || [];
  return (
    <NotesMainPanel
      title={t('settingsPages.cannedTitle')}
      subtitle={t('settingsPages.cannedSubtitle')}
      items={items}
      emptyTitle={t('settingsPages.cannedEmpty')}
    />
  );
}
